<script lang="ts">
import { VNode, CreateElement } from 'vue';
import { defineComponent, PropType } from '@vue/composition-api';

/** Wrapper around native Intersection Observer for a single element */
export default defineComponent({
  name: 'BaseIntersection',
  props: {
    root: {
      type: Object as PropType<HTMLElement>,
      default: undefined,
    },
    rootMargin: {
      type: String,
      default: undefined,
    },
    threshold: {
      type: Array as PropType<number[]>,
      default: undefined,
    },
  },
  emits: ['enter', 'leave', 'change', 'destroy'],
  setup() {
    return {
      observer: null! as IntersectionObserver,
    };
  },
  mounted(): void {
    const options = { ...this.$props };
    this.observer = new IntersectionObserver((entries) => {
      const target = entries[entries.length - 1];

      target.isIntersecting
        ? this.$emit('enter', target)
        : this.$emit('leave', target);

      this.$emit('change', target);
    }, options);

    const target = this.$slots.default![0];
    this.observer.observe(target.elm as Element);
  },
  destroyed(): void {
    this.observer.disconnect();
    this.$emit('destroy');
  },
  render(createElement: CreateElement): VNode {
    return this.$slots.default ? this.$slots.default[0] : createElement();
  },
});
</script>
